export default "__VITE_ASSET__Cj6$j306__"